import {
  put, all, call, select, takeEvery, takeLatest, fork, cancel,
} from 'redux-saga/effects';

import { show as showNotification } from 'circe/notifications/actions';
import { exception } from 'circe/logger';
import * as I18n from 'circe/I18n';
import {
  fetch, fetched, fetchNext, fetchPrev, fetching, cache,
} from './actions';
import * as API from './api';

import viewSaga from './View/saga';
import {
  getHasNext,
  getHasPrev,
  getNextCursor,
  getPrevCursor,
  getFromCache,
  getFilters,
} from './selectors';

function* doFetch(context, { payload }) {
  try {
    const { filters, append } = payload;
    const state = yield select();

    // {
    //   const cache = yield call(getFromCache, state, filters.cursor);
    //
    //   if (cache && cache.data) {
    //     const { data, ...meta } = cache;
    //     yield put(fetched(data, meta));
    //
    //     return;
    //   }
    // }

    const resp = yield call(
      API.fetch,
      {
        ...filters,
      },
      filters.cursor,
    );

    const meta = {
      append,
      filters: {
        ...filters,
        cursor: null,
      },
      cursor: filters.cursor,
      nextCursor: resp.nextPage && resp.nextPage.hasResults ? resp.nextPage.cursor : null,
      prevCursor: resp.prevPage && resp.prevPage.hasResults ? resp.prevPage.cursor : null,
    };

    yield put(fetched(resp.results, meta));

    yield put(
      cache(meta.nextCursor, {
        prevCursor: filters.cursor,
      }),
    );

    yield put(
      cache(filters.cursor, {
        data: resp.results,
        ...meta,
        prevCursor: !filters.cursor ? undefined : meta.prevCursor,
      }),
    );
  } catch (e) {
    yield put(
      showNotification(
        I18n.str('unableToLoadManifestRequests', 'Unable To Load Manifest Requests'),
        'error',
      ),
    );
    yield put(fetched());
    exception(e);
  }
}

function* doFetchNext(context, { payload }) {
  const { append } = payload;

  const state = yield select();

  const hasNextPage = yield call(getHasNext, state);
  const filters = yield call(getFilters, state);

  if (!hasNextPage) {
    return;
  }

  const cursor = yield call(getNextCursor, state);

  yield put(fetching(append));

  yield call(
    doFetch,
    context,
    fetch(
      {
        ...filters,
        cursor,
      },
      append,
    ),
  );
}

function* doFetchPrev(context) {
  const state = yield select();

  const hasPrevPage = yield call(getHasPrev, state);

  if (!hasPrevPage) {
    return;
  }

  const cursor = yield call(getPrevCursor, state);

  yield put(fetching());

  yield call(doFetch, context, fetch({ cursor }));
}

export default function* (context) {
  yield all([
    takeLatest(fetch().type, doFetch, context),
    takeLatest(fetchNext().type, doFetchNext, context),
    takeLatest(fetchPrev().type, doFetchPrev, context),
    viewSaga(context),
  ]);
}
